import React, { useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { getGoogleCaptchaKey } from "../../utils/general-config";
import { useParams } from "react-router-dom";

const RECAPTCHA_SITE_KEY = getGoogleCaptchaKey();

const GoogleCaptcha = ({ onCaptchaSuccess }) => {
  const recaptchaRef = useRef();
  const { locale } = useParams();
  const handleChange = (token) => {
    console.log("Token received:", token);
    console.log("Token length:", token?.length);
    console.log("Token type:", typeof token);

    if (!token) {
      return;
    }
    onCaptchaSuccess(token);
  };

  return (
    <div>
      <ReCAPTCHA
        sitekey={RECAPTCHA_SITE_KEY}
        ref={recaptchaRef}
        theme="light"
        onChange={handleChange}
        hl={locale}
      />
    </div>
  );
};

export default GoogleCaptcha;
